var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00323 14.6693C4.32132 14.6693 1.33655 11.6845 1.33655 8.00258C1.33655 4.3207 4.32132 1.33594 8.00323 1.33594C11.6851 1.33594 14.6699 4.3207 14.6699 8.00258C14.6699 11.6845 11.6851 14.6693 8.00323 14.6693ZM8.00323 13.3359C10.9488 13.3359 13.3366 10.9481 13.3366 8.00258C13.3366 5.05708 10.9488 2.66927 8.00323 2.66927C5.05769 2.66927 2.66988 5.05708 2.66988 8.00258C2.66988 10.9481 5.05769 13.3359 8.00323 13.3359ZM5.66988 9.33592H9.33656C9.52063 9.33592 9.6699 9.18672 9.6699 9.00258C9.6699 8.81852 9.52063 8.66925 9.33656 8.66925H6.66989C5.74941 8.66925 5.00321 7.92305 5.00321 7.00258C5.00321 6.08213 5.74941 5.33594 6.66989 5.33594H7.33656V4.0026H8.66989V5.33594H10.3366V6.66925H6.66989C6.48579 6.66925 6.33655 6.81852 6.33655 7.00258C6.33655 7.18672 6.48579 7.33592 6.66989 7.33592H9.33656C10.257 7.33592 11.0032 8.08212 11.0032 9.00258C11.0032 9.92305 10.257 10.6693 9.33656 10.6693H8.66989V12.0026H7.33656V10.6693H5.66988V9.33592Z",
    fill: "#96999C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.ae7f4d373dd3c3c1c8c105d727e84ea2.svg";
export { ForwardRef as ReactComponent };